import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../branding.css";
import LoginModal from "./auth/LoginModal";

const BrandingLanding = () => {
  const [showLogin, setShowLogin] = useState(false);

  return (
  <div style={{ width: "100vw", height: "100vh", position: "relative" }}>
    {/* Laser grids isolated in their own overflow:hidden layer */}
    <div style={{ position: "absolute", inset: 0, overflow: "hidden", zIndex: 1 }}>
      <div className="laser-container">
        <div className="laser-grid top"></div>
        <div className="laser-grid bottom"></div>
      </div>
      {/* Radial center glow — restores depth from original */}
      <div className="center-glow"></div>
    </div>
    {/* TOP CARD — outside branding-wrapper so transform context doesn't break positioning */}
    <div className="popup-top-card">
      <div className="popup-inner">
        <div className="popup-headline">You imagine it, we build it.</div>
        <div className="popup-body">Data pipelines. Web design. E-commerce. Marketing systems. Custom AI tools. RAMDESIGNWORKS is a professional team operating at the edge of what AI makes possible.</div>
        <Link to="/build-for-me" className="popup-cta-main">
          <span className="cta-prompt">&gt;_</span> Enter for More Information <span className="cta-chevron">&raquo;</span>
        </Link>
      </div>
    </div>

    <div className="branding-wrapper">
      <div className="steel-bar">
        <div className="twinkle t1"></div>
        <div className="twinkle t2"></div>
        <div className="twinkle t3"></div>
        <div className="twinkle t4"></div>
        <div className="twinkle t5"></div>
      </div>
      <div className="content-hover-zone">
        <div className="content">
          <h1>RAMDESIGNWORKS</h1>
          <p className="subtitle">AI-Powered Professional Services</p>
        </div>
      </div>
    </div>

    {/* BOTTOM CARD — outside branding-wrapper, below the bar */}
    <div className="popup-bottom-card">
      <span className="popup-training-note">
        we offer AI training too! &nbsp;
        <a href="https://theoperatormethod.com" target="_blank" rel="noopener noreferrer" className="popup-cta-secondary">
          <span className="cta-prompt">&gt;_</span> The Operator Method <span className="cta-chevron">&raquo;</span>
        </a>
      </span>
    </div>
    {/* Subdued access trigger — bottom-right corner, low opacity */}
    <button
      className="lm-trigger"
      onClick={() => setShowLogin(true)}
      aria-label="Client access"
      title=""
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
    </button>

    {/* Login modal */}
    {showLogin && <LoginModal onClose={() => setShowLogin(false)} />}
  </div>
  );
};

export default BrandingLanding;
